// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "5a8fc192e4e4381dca743cec6abf79c9" + ".js";
};